import React from "react";
import { View, StyleSheet, Image, TouchableHighlight, Button, TouchableNativeFeedback } from "react-native";
//import { MaterialCommunityIcons } from "@expo/vector-icons";
//import Swipeable from "react-native-gesture-handler/Swipeable";

import Text from "../Text";
import colors from "../../config/colors";
import { TouchableOpacity } from "react-native-gesture-handler";

function ListItem({
  title,
  titleRol,
  titleFollowers,
  subTitleFollowers,
  titleFollowed,
  subTitleFollowed,
  subTitle,
  image,
  IconComponent,
  onPress,
  onPress1,
  onPress2,
  renderRightActions
}) {
  return (
//    <Swipeable renderRightActions={renderRightActions}>
      <TouchableHighlight underlayColor={colors.light} onPress={onPress}>
        <View style={styles.container}>
          {IconComponent}
          {image && <Image style={styles.image} source={{ uri:image}}  />}
          <View style={styles.detailsContainer}>
            <Text style={styles.subTitle} numberOfLines={1}>
              {titleRol}
            </Text>
            {subTitle && (
              <Text style={styles.subTitle} numberOfLines={2}>
                {subTitle}
              </Text>
            )}
          </View>
          <TouchableOpacity onPress = { onPress2  }>
           <View style={styles.detailsContainer}>
            <Text style={styles.subTitle} numberOfLines={1}>
              {titleFollowed}
            </Text>
            {subTitle && (
              <Text style={styles.subTitle} numberOfLines={2}>
                {subTitleFollowed}
              </Text>
            )}
          </View>
          </TouchableOpacity>
           <TouchableHighlight onPress = { onPress1 }>
              <View style={styles.detailsContainer}>
                <Text style={styles.subTitle} numberOfLines={1}>
                  {titleFollowers}
                </Text>
                {subTitle && (
                  <Text style={styles.subTitle} numberOfLines={2}>
                    {subTitleFollowers}
                  </Text>
                )}
              </View>
          </TouchableHighlight>
          
          {/* <MaterialCommunityIcons
            color={colors.medium}
            name="chevron-right"
            size={25}
          /> */}

        </View>
      </TouchableHighlight>
    //</Swipeable>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    padding: .75,
    backgroundColor: colors.white,
    justifyContent: 'space-evenly',
  },
  detailsContainer: {
    marginLeft: 0,
    justifyContent: "flex-start",
    alignItems: "center",
  },
  image: {
    width: 80,
    height: 80,
    borderRadius: 40,
  },
  imageButton: {
    backgroundColor:'yellow',
    width: 70,
    height: 70,
    borderRadius: 35,
  },
  subTitle: {
    color: colors.dark,
    textAlign:'left',
    fontSize: 19,
    marginRight: '5%',
  },
  title: {
    fontWeight: "500",
  },
});

export default ListItem;

